import { useState } from "react";
import { useToast } from "../admin/components/Toast";
import {
  login as apiLogin,
  signup as apiSignup,
  verifyEmail as apiVerifyEmail,
} from "../api/auth";

const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();

  const login = async (email, password) => {
    setLoading(true);
    try {
      const data = await apiLogin(email, password);
      addToast("Login successful!", "success");
      localStorage.setItem("token", data.access_token);
      return data;
    } catch (err) {
      addToast(err?.response?.data?.detail || "Login failed", "error");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const signup = async (email, password, location) => {
    setLoading(true);
    try {
      const data = await apiSignup(email, password, location);
      addToast(
        "Signup successful! Please check your email to verify your account.",
        "success"
      );
      return data;
    } catch (err) {
      addToast(err?.response?.data?.detail[0]?.msg || "Signup failed", "error");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const verifyEmail = async (token) => {
    setLoading(true);
    try {
      const data = await apiVerifyEmail(token);
      addToast("Email verified! You can now log in.", "success");
      return data;
    } catch (err) {
      addToast(
        err?.response?.data?.detail[0]?.msg || "Email verification failed",
        "error"
      );
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { login, signup, verifyEmail, loading };
};

export default useAuth;
